import { ToastContainer } from "@/components/ui/Toast";
import { useToastStore } from "@/stores/useToastStore";

export const GlobalToastContainer = () => {
	const toasts = useToastStore((state) => state.toasts);
	const dismissToast = useToastStore((state) => state.dismissToast);

	return (
		<ToastContainer toasts={toasts} onDismiss={dismissToast} showCloseButton />
	);
};
